<h2 mat-dialog-title>Impersonate User</h2>

<mat-dialog-content>
    <p>Search by name or email to find a user to impersonate.</p>

    <mat-form-field class="w-100">
        <mat-label>Select user</mat-label>
        <mat-select [formControl]="userControl" [disabled]="loading">
            <mat-option>
                <ngx-mat-select-search
                    [formControl]="searchControl"
                    placeholderLabel="Search by namne or email…"
                    noEntriesFoundLabel="No users found"
                ></ngx-mat-select-search>
            </mat-option>

            @if (!hasSearched && !loading) {
                <mat-option disabled>Type to search for users…</mat-option>
            }

            @if (hasSearched && !loading && tenantGroups.length === 0) {
                <mat-option disabled>No users found</mat-option>
            }

            @for (group of tenantGroups; track group.tenantId) {
                <mat-optgroup [label]="group.label">
                    @for (user of group.users; track user.id) {
                        <mat-option [value]="user.id">{{ user.name }} ({{ user.email }})</mat-option>
                    }
                </mat-optgroup>
            }
        </mat-select>
        @if (loading) {
            <mat-hint>Searching…</mat-hint>
        }
    </mat-form-field>

    @if (errorMessage) {
        <p class="text-danger mb-0">{{ errorMessage }}</p>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="warn" (click)="confirm()" [disabled]="!userControl.value || loading">
        Impersonate
    </button>
</mat-dialog-actions>

